 

 



 
 

 import { LogLevel } from "@azure/msal-browser";

// Resolve the MSAL redirect URI from the host the app is served on, so the same
// build works in every environment (prd / qa / local) with no manual edits.
// IMPORTANT: every value below MUST be registered as a Redirect URI (SPA platform)
// on the Entra app registration (clientId f7e54fc1-...), matching EXACTLY including
// any trailing slash — otherwise Azure AD returns AADSTS50011 (redirect mismatch).
const REDIRECT_URIS = {
  "shamlrecruit.awjholding.com": "https://shamlrecruit.awjholding.com",          // prd
  "shamlrecruit-qa.awjholding.com": "https://shamlrecruit-qa.awjholding.com/",   // qa
  "ahcrecruitment.azurewebsites.net": "https://ahcrecruitment.azurewebsites.net",       // prd default host
  "ahcrecruitment-qa.azurewebsites.net": "https://ahcrecruitment-qa.azurewebsites.net", // qa default host
  "localhost": "http://localhost:3000",
};

const resolveRedirectUri = () => {
  if (typeof window === "undefined") return "https://shamlrecruit.awjholding.com";
  // Known hosts use their exact registered URI; anything else falls back to the
  // current origin (also must be registered in Entra to work).
  return REDIRECT_URIS[window.location.hostname] || window.location.origin;
};

// Production hosts. On these, the app authenticates silently (ssoSilent) and skips
// the visible login page; every other host (qa / dev / localhost) shows it.
const PROD_HOSTS = new Set([
  "shamlrecruit.awjholding.com",
  "ahcrecruitment.azurewebsites.net",
]);

export const isProduction = () => {
  if (typeof window === "undefined") return false;
  return PROD_HOSTS.has(window.location.hostname);
};

export const msalConfig = {
  auth: {
    clientId: "f7e54fc1-bbf6-4439-b2de-f3f134b1427a",
    authority: "https://login.microsoftonline.com/9c8d0d3e-b6ba-4ef3-b023-37952c89fc65",
    redirectUri: resolveRedirectUri(),
  },
  cache: {
  cacheLocation: "localStorage",  // persist tokens in localStorage
    storeAuthStateInCookie: true,  // or true if you experience issues with some browsers
 
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message) => {
        console.log(message);
      },
      piiLoggingEnabled: false,
      LogLevel: LogLevel.Warning,
    },
  },
  // other configs
};

export const loginRequest = {
  scopes: ["User.Read" ,"User.Read.All","Calendars.Read"],
};